var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showsignature,
          expression: "showsignature",
        },
      ],
      staticClass: "emap-flow-esignature-m",
      style: [{ height: _vm.vh + "px" }],
    },
    [
      _c(
        "div",
        { staticClass: "signature-pad", attrs: { id: "signature-pad" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "signature-pad--body" }, [
            _c("canvas", { ref: "canvas" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "signature-pad--footer" }, [
            _c("div", { staticClass: "signature-pad--actions" }, [
              _c(
                "button",
                {
                  staticClass: "button back",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showsignature = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button clear",
                  attrs: { type: "button" },
                  on: { click: _vm.clearHandle },
                },
                [_vm._v("清空")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button save",
                  attrs: { type: "button" },
                  on: { click: _vm.confirmHandle },
                },
                [_vm._v("确定")]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signature-pad--header" }, [
      _c("div", { staticClass: "signature-pad--title" }, [_vm._v("签名区域")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }